import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
  SupplierBill, SupplierBillCreateDTO, SupplierServiceBillCreateDTO, SupplierBillResponse,
  BillEditDTO, SupplierBillEdit,
} from '../interfaces/procurement/supplierBill.interface';

export const SupplierBillService = {
  listByPurchaseOrder: async (purchaseOrderId: string, page = 0, size = 10): Promise<SupplierBillResponse> =>
    (await axios.get(`${ENDPOINTS.SUPPLIER_BILL.LIST_BY_PURCHASE_ORDER(purchaseOrderId)}?page=${page}&size=${size}`)).data,
  listBySupplier: async (supplierId: string, page = 0, size = 10): Promise<SupplierBillResponse> =>
    (await axios.get(`${ENDPOINTS.SUPPLIER_BILL.LIST_BY_SUPPLIER(supplierId)}?page=${page}&size=${size}`)).data,
  listByInstitution: async (page = 0, size = 10): Promise<SupplierBillResponse> => {
    const institutionId = AuthService.getSelectedInstitution()!!;
    return (await axios.get(`${ENDPOINTS.SUPPLIER_BILL.LIST_BY_INSTITUTION(institutionId)}?page=${page}&size=${size}`)).data;
  },
  getById: async (id: string): Promise<SupplierBill> =>
    (await axios.get(ENDPOINTS.SUPPLIER_BILL.GET_BY_ID(id))).data,
  create: async (dto: SupplierBillCreateDTO): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.CREATE, dto)).data,
  /** W3-F: account-coded service bill (no PO/GRN), e.g. a C&F agent's bill debiting import clearing. */
  createServiceBill: async (dto: SupplierServiceBillCreateDTO): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_SERVICE_BILL, dto)).data,
  reverse: async (id: string): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.REVERSE(id))).data,
  releaseBlock: async (id: string, justification: string): Promise<SupplierBill> =>
    (await axios.post(ENDPOINTS.SUPPLIER_BILL.RELEASE_BLOCK(id), { justification })).data,
  edit: async (id: string, dto: BillEditDTO): Promise<SupplierBill> =>
    (await axios.put(ENDPOINTS.SUPPLIER_BILL.EDIT(id), dto)).data,
  editHistory: async (id: string): Promise<SupplierBillEdit[]> =>
    (await axios.get(ENDPOINTS.SUPPLIER_BILL.EDIT_HISTORY(id))).data,
};
